export default __webpack_public_path__ + "static/media/gift.c5ce331e.svg";